module.exports = __webpack_public_path__ + "static/media/ninety_percent.54d2c541.png";